<template>
  <div v-show="displayFrontend" :class="{questions__save: safeFreeze}" class="questions">

    <h1 class="questions__header">{{ $t("Employee Management") }}</h1>
    <h2 class="questions__subheader">{{ $t("Sort employees by") }}</h2>
    <b-form-radio-group
      id="btn-radios-2"
      v-model="permissions.sortNames"
      button-variant="outline-primary"
      buttons
      name="radio-btn-outline">
      <b-form-radio value="First names">
        {{ $t("Firstname") }}
      </b-form-radio>
      <b-form-radio value="Last names">
        {{ $t("Lastname") }}
      </b-form-radio>
      <b-form-radio value="Employee number">
        {{ $t("Employee number") }}
      </b-form-radio>
    </b-form-radio-group>

    <h1 class="question--marginTop questions__header">{{ $t("Labels") }}</h1>
    <p class="questions__subheader">{{
        $t("Are there general characteristics, skills or trainings that you take into account when making work schedules? For example, do you need a minimum number of FAFS officers? Or do you want to recognize what level of experience an employee has?")
      }}</p>

    <h2 class="questions__subheader">{{ $t("General") }}</h2>
    <b-form-textarea
      v-model="permissions.labelSettings[0].general"
      class="questions__textarea"
      rows="3"/>

    <h2 class="questions__subheader">{{ $t("Skills") }}</h2>
    <b-form-textarea
      v-model="permissions.labelSettings[0].skills"
      class="questions__textarea"
      rows="3"/>

    <h2 class="questions__subheader">{{ $t("Training") }}</h2>
    <b-form-textarea
      v-model="permissions.labelSettings[0].education"
      class="questions__textarea"
      rows="3"/>

    <h1 class="question--marginTop questions__header">{{ $t("View details of co-workers") }}</h1>
    <b-form-checkbox
      v-model="permissions.daySchedule"
      class="checkbox"
      name="check-button"
      switch>
      {{ $t("See daily schedule") }}
    </b-form-checkbox>

    <b-form-checkbox
      v-model="permissions.weekSchedule"
      class="checkbox"
      name="check-button"
      switch>
      {{ $t("View weekly schedule") }}
    </b-form-checkbox>

    <b-form-checkbox
      v-model="permissions.holidaySchedule"
      class="checkbox"
      name="check-button"
      switch>
      {{ $t("See vacation schedule") }}
    </b-form-checkbox>

    <h2 class="questions__subheader">{{ $t("Employees may see the above schedules from:") }}</h2>
    <b-form-radio-group
      id="btn-radios-2"
      v-model="permissions.viewSchedule"
      button-variant="outline-primary"
      buttons
      name="radio-btn-outline">
      <b-form-radio value="See own department">
        {{ $t("Only their own department(s)") }}
      </b-form-radio>
      <b-form-radio value="See full company">
        {{ $t("The entire establishment") }}
      </b-form-radio>
    </b-form-radio-group>

    <h1 class="question--marginTop questions__header">{{ $t("Employee permissions") }}</h1>
    <b-form-checkbox
      v-model="permissions.seeEndTimeShift"
      class="checkbox"
      name="check-button"
      switch>
      {{ $t("Employees allowed to see end time of a shift") }}
    </b-form-checkbox>

    <b-form-checkbox
      v-model="permissions.handoverShift"
      class="checkbox"
      name="check-button"
      switch>
      {{ $t("Employees can swap shifts") }}
    </b-form-checkbox>

    <b-form-checkbox
      v-model="permissions.registerHours"
      class="checkbox"
      name="check-button"
      switch>
      {{ $t("Employees can register hours for their themselves") }}
    </b-form-checkbox>

    <b-form-checkbox
      v-model="permissions.clockInApp"
      v-show="whatContractType === 'PROPLUS'"
      class="checkbox"
      name="check-button"
      switch>
      {{ $t("Employees can clock in the app if they are on the schedule") }}
    </b-form-checkbox>

    <b-form-checkbox
      v-model="permissions.clockInAppGeo"
      v-show="permissions.clockInApp"
      class="checkbox"
      name="check-button"
      switch>
      {{ $t("Employees can only clock-in if their phone is within 150 meters from the location") }}
    </b-form-checkbox>

    <h2 class="questions__subheader">{{ $t("Vacation request period, in days") }}</h2>
    <input
      v-model="permissions.holidayDayAdvance"
      v-b-popover.hover.left="$t('There may be a time limit for applying for leave. For example: an employee must request his leave 1 week in advance. Within the chosen period, the requests are blocked in Dyflexis and the employee must personally go to his manager.')"
      class="form-control"
      type="number"/>

    <h2 class="questions__subheader">{{ $t("Unavailability request period, in days") }}</h2>
    <input
      v-model="permissions.leaveDayAdvance"
      v-b-popover.hover.left="$t('There may be a time limit for applying for leave. For example: an employee must request his leave 1 week in advance. Within the chosen period, the requests are blocked in Dyflexis and the employee must personally go to his manager.')"
      class="form-control"
      type="number"/>

    <h2 class="questions__subheader">{{ $t("Remarks") }}</h2>
    <div>
      <b-form-textarea
        v-model="permissions.permissionRemarks"
        class="questions__textarea footerMargin"
        rows="3"/>
    </div>

    <input :value="$t('Save')" type="button" @click="handleSave"/>
    <p v-show="showSaveStatus" class="questions--savesuccess">{{ $t("Saved successfully!") }}</p>
  </div>
</template>

<script>
import SystemRequestService from "@/SystemRequestService";
import GlobalFunctions from "@/GlobalFunctions";

export default {
  name: "EmployeeSettings",
  data() {
    return {
      displayFrontend: false,
      safeFreeze: false,
      showSaveStatus: false,
      showPayrollConnection: false,
      whatContractType: null,
      permissions: {
        daySchedule: false,
        handoverShift: false,
        holidayDayAdvance: null,
        leaveDayAdvance: null,
        holidaySchedule: false,
        registerHours: false,
        clockInApp: false,
        clockInAppGeo: false,
        seeEndTimeShift: false,
        sortNames: '',
        viewSchedule: '',
        weekSchedule: false,
        labelSettings: [{
          general: null,
          skills: null,
          education: null,
        }],
        permissionRemarks: null,
      }
    };
  },
  async beforeMount() {
    const result = await SystemRequestService.getProject(this.$route.params.hashedId);
    if (!result) {
      alert(this.$t("Error while obtaining your details. Please try again later or contact your Dyflexis consultant."));
      return;
    }

    this.showPayrollConnection = result.payrollConnection;
    this.whatContractType = result.contractType;
    this.permissions.daySchedule = result.employeePermissionDaySchedule;
    this.permissions.handoverShift = result.employeePermissionHandoverShift;
    this.permissions.holidaySchedule = result.employeePermissionHolidaySchedule;
    this.permissions.registerHours = result.employeePermissionRegisterHours;
    this.permissions.clockInApp = result.employeePermissionClockInApp;
    this.permissions.clockInAppGeo = result.employeePermissionClockInAppGeo;
    this.permissions.seeEndTimeShift = result.employeePermissionSeeEndTimeShift;
    this.permissions.sortNames = result.employeePermissionSortNames;
    this.permissions.holidayDayAdvance = result.employeePermissionHolidayDayAdvance;
    this.permissions.leaveDayAdvance = result.employeePermissionLeaveDayAdvance;
    this.permissions.viewSchedule = result.employeePermissionViewSchedule;
    this.permissions.weekSchedule = result.employeePermissionWeekSchedule;
    this.permissions.permissionRemarks = result.employeePermissionRemarks;

    try {
      if (result.labelSettings != null) {
        this.permissions.labelSettings = JSON.parse(result.labelSettings);
      }
    } catch (error) {
      this.permissions.labelSettings = result.labelSettings;
    }

    GlobalFunctions.setReadOnly(result.isSigned);
    localStorage.setItem('startingObject', JSON.stringify(this.permissions));
    this.displayFrontend = true;
  },
  beforeRouteLeave: function (to, from, next) {
    if (!GlobalFunctions.acceptPageLeave(this.permissions, this.$t("You have made changes without saving them. Press cancel to ignore these changes and leave the page."))) {
      this.handleSave(false);
    }
    next();
  },
  methods: {
    async handleSave(saveInitialObject) {
      this.safeFreeze = true;

      let old = this.permissions.labelSettings;
      this.permissions.labelSettings = JSON.stringify(this.permissions.labelSettings);

      const result = await SystemRequestService.updateProject(this.permissions, this.$route.params.hashedId);
      if (!result || result.status !== 'success') {
        alert(this.$t("Error while updating, please send a screenshot of the fields on this page to your Dyflexis consultant!"));
        return;
      }

      this.permissions.labelSettings = old;
      if (saveInitialObject !== false) {
        localStorage.setItem('startingObject', JSON.stringify(this.permissions));
      }

      this.safeFreeze = false;
      this.showSaveStatus = true;
      setTimeout(() => {
        this.showSaveStatus = false;
      }, 3000);
    },
  }
};
</script>
